export default "__VITE_ASSET__BcbC6h8q__"